import { Injectable, signal } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class NotificationService {
  message = signal<{ title: string; message: string; type: 'success' | 'error' } | null>(null);

  showNotification(message: string, type: 'success' | 'error', title = 'Error') {
    this.message.set({ title, message, type });

    setTimeout(() => {
      this.clearNotification();
    }, 3000);
  }

  clearNotification() {
    this.message.set(null);
  }
}
